import { Component, OnDestroy, OnInit } from '@angular/core';
import { NotificationService } from '../notification.service';
import { ToastrService } from 'ngx-toastr';
import { DtoDataAlertCategory, DtoDataAlertSubscription, DtoDataAlertType } from '../../../../models/notifications.model';
import { HttpErrorResponse } from '@angular/common/http';
import { timestamp } from 'rxjs';

@Component({
  selector: 'app-data-alerts',
  standalone: false,
  templateUrl: './data-alerts.component.html',
  styleUrl: './data-alerts.component.scss'
})
export class DataAlertsComponent
  implements OnInit, OnDestroy {
  isLoading: boolean = true;
  canPauseAll:boolean = false;
  canResumeAll:boolean = false;
  dataAlertCategories: DtoDataAlertCategory[] = [];
  SubscribedItems: DtoDataAlertSubscription[] = [];
  AlertTypes: DtoDataAlertType[] = [];

  AllSubscribed: DtoDataAlertCategory = {
    dataAlertCategoryId: 0,
    categoryCode: '',
    categoryName: 'All Subscribed',
    subscriptionCount: 0,
    activeCount:0,
    isFiltered: true
  }


  constructor(
    private toasterService: ToastrService,
    private notificationService: NotificationService
  ) {

  }

  ngOnInit(): void {
    this.isLoading = true;
    this.fetchDataAlertCategories()
  }

  ngOnDestroy() {

  }

  reset() {
    this.dataAlertCategories = [];
    this.SubscribedItems = [];
    this.AlertTypes = [];

  }

  handlesubscriptionTypeChange(subscriptionType: DtoDataAlertCategory, isChecked: boolean) {

    for (var nt of this.dataAlertCategories) {
      nt.isFiltered = false;
    }

    subscriptionType.isFiltered = isChecked;
    if (!isChecked) {
      this.AllSubscribed.isFiltered = true;
      this.fetchDataAlertItems(this.AllSubscribed);
    }
    else {
      this.fetchDataAlertItems(subscriptionType);
    }
  }

  getSectorId(): number {
    let sectorId = Number(sessionStorage.getItem('sector'));
    return sectorId;
  }

  pause_all(){
    const sectorId = this.getSectorId();
    this.notificationService.pauseAllDataAlertSubscriptions(sectorId)
      .subscribe({
        next: (resposne:DtoDataAlertSubscription[])=> {
            this.fetchDataAlertCategories();
        },
        error: (err: HttpErrorResponse) => {
          if (err.error) {
             this.fetchDataAlertCategories();
            this.toasterService.error(err.error, 'Error');
          }
        }
      });
  }

  resume_all(){
    const sectorId = this.getSectorId();
    this.notificationService.resumeAllDataAlertSubscriptions(sectorId)
      .subscribe({
        next: (resposne:DtoDataAlertSubscription[])=> {
            this.fetchDataAlertCategories();
        },
        error: (err: HttpErrorResponse) => {
          if (err.error) {
             this.fetchDataAlertCategories();
            this.toasterService.error(err.error, 'Error');
          }
        }
      });
  }
  subscribe_to_alert(item: DtoDataAlertType) {
    return this.subscribe_toggle(item, true);
  }

  unsubscribe_from_alert(item: DtoDataAlertType) {
    return this.subscribe_toggle(item, false);
  }

  subscribe_toggle(item: DtoDataAlertType, activate: boolean) {
    //var thisSubscription = this.SubscribedItems.find(x => x.dataAlertId == item.id);

    var data = item.mySubscription;
    if (data == null) {
      data = {
        id: 0,
        dataAlertId: item.id,
        startDate: new Date().toISOString().slice(0, 10),
        endDate: null,
        dataAlertCategoryId: item.categoryId
      } as DtoDataAlertSubscription;
    }
    if(activate){
      if(data.endDate!=null)
      {
        data.startDate=new Date().toISOString().slice(0, 10);
        data.endDate = null;
      }
    }
    else{
      data.endDate = new Date().toISOString().slice(0, 10);
    }
  

    this.notificationService.saveDataAlertsubscription(data).subscribe(
      {
        next: (response) => {
          data = response;
          const dataAlertId = item.mySubscription?.dataAlertId;
          
          const items = this.SubscribedItems.filter(
            sub => sub.dataAlertId !== dataAlertId
          );
          
          if(data.endDate == null)
          {
            items.push(data)
            item.mySubscription = data;
          }
          else{
            item.mySubscription = null;
          }
          
          this.SubscribedItems = items;

          if(this.AllSubscribed.isFiltered){
            this.AlertTypes = this.AlertTypes.filter(x=>x.mySubscription!=null);
          }
          else{
            this.AlertTypes = this.AlertTypes.filter(x=> x.isEnabled || (x.mySubscription!=null));
          }

          this.calculateSubscriptionCategoryCount();
        },
        error: (err: HttpErrorResponse) => {
          if (err.error) {
            this.toasterService.error(err.error, 'Error');
          }
        }
      }
    );
  }

  fetchDataAlertCategories() {
    this.notificationService.fetchDataAlertCategories(this.getSectorId())
      .subscribe({
        next: (response) => {
          if (response.length > 0) {
            this.dataAlertCategories = [this.AllSubscribed];
            this.dataAlertCategories.push(...response);
            //init extra attributes
            for (var nt of this.dataAlertCategories) {
              nt.subscriptionCount = 0;
              nt.activeCount = 0;
              nt.isFiltered = false;
            }
            this.AllSubscribed.isFiltered = true;
            this.fetchDataAlertSubscriptions(() => this.fetchDataAlertItems(this.AllSubscribed));
          }
          else {
            this.reset();
          }
          this.isLoading = false;
        },
        error: (err: HttpErrorResponse) => {
          this.isLoading = false;
          this.reset();
          if (err.error) {
            this.toasterService.error(err.error, 'Error');
          }
        }
      });
  }

  calculateSubscriptionCategoryCount() {
    const grouped = this.SubscribedItems.reduce((groups, item) => {
      (groups[item.dataAlertCategoryId] ??= []).push(item);
      return groups;
    }, {} as Record<number, DtoDataAlertSubscription[]>);

    this.dataAlertCategories.forEach(category => {
      var itemsSubscribed: DtoDataAlertSubscription[];
      if (category.dataAlertCategoryId == 0)
        itemsSubscribed = this.SubscribedItems;
      else
        itemsSubscribed = grouped[category.dataAlertCategoryId]??[];

      category.activeCount=itemsSubscribed.filter(x=>x.endDate==null).length;
      category.subscriptionCount = itemsSubscribed.length;
    });

    this.canPauseAll = this.SubscribedItems.some(x=>x.endDate==null);
    this.canResumeAll = this.SubscribedItems.some(x=>x.endDate!=null);
  }

  fetchDataAlertSubscriptions(callback: Function) {
    this.notificationService.fetchDataAlertSubscriptions(this.getSectorId())
      .subscribe({
        next: (response) => {
          this.SubscribedItems = response;
          this.calculateSubscriptionCategoryCount();

          if (callback) callback();
        },
        error: (err: HttpErrorResponse) => {
          this.reset();
          if (err.error) {
            this.toasterService.error(err.error, 'Error');
          }
        }
      });
  }

  fetchDataAlertItems(value: DtoDataAlertCategory) {

    this.notificationService.fetchDataAlertTypes(this.getSectorId(), value.dataAlertCategoryId)
      .subscribe({
        next: (response) => {
          this.AlertTypes = response;

          this.AlertTypes.forEach(x => {
            var match = this.SubscribedItems.find(si => si.dataAlertId == x.id)
            
            if (match == null)
              x.mySubscription = null;
            else
              x.mySubscription = match;
          });

        },
        error: (err: HttpErrorResponse) => {
          this.reset();
          if (err.error) {
            this.toasterService.error(err.error, 'Error');
          }
        }
      });
  }
}
